import React, { Component } from "react";
import axios from "axios";
import {
  message,
  Drawer,
  Form,
  Col,
  Input,
  InputNumber,
  Select,
  Button,
  Space,
  Switch,
  Typography,
} from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

class RatesDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      internet: [],
    };
    this.formRef = React.createRef();
  }
  componentDidMount() {
    this.getInternetPlans();
  }
  componentDidUpdate(prevProps) {
    if (this.props.openModal && !prevProps.openModal) {
      if (this.formRef.current) this.formRef.current.resetFields();
    }
    if (prevProps !== this.state && this.formRef.current) {
      const { rate } = this.props;

      this.formRef.current.setFieldsValue({
        section: rate.section,
        title: rate.title,
        description: rate.description,
        price: rate.price ? rate.price : "",
        discounts_list:
          rate.discounts && rate.discounts.length > 0 ? rate.discounts : [],
      });
    }
  }
  getInternetPlans() {
    axios
      .post("https://dev.nadu.xyz/dev/admin/getActiveInternet")
      .then((res) => {
        if (typeof res !== "undefined") {
          this.setState({
            internet: res.data.map((internet) => ({
              value: internet.uuid,
              label: `${internet.internet_type} | ${internet.title} (${internet.price} €)`,
              props: internet,
            })),
          });
        }
      })
      .catch((error) => message.error(error));
  }
  render() {
    return (
      <Drawer
        title={this.props.isNewRate ? "Crear servicio" : "Editar servicio"}
        width={720}
        onClose={() => this.props.handleCancelForm()}
        open={this.props.openModal}
      >
        <Form ref={this.formRef} layout="vertical" hideRequiredMark>
          <Col span={24}>
            <Form.Item name="section" label="Sección">
              <Select
                defaultValue={
                  this.props.rate ? this.props.rate.section : "phone"
                }
                onChange={(value) => this.props.handleInputChange(value)}
              >
                <Select.Option value="phone">Movil</Select.Option>
                <Select.Option value="internet">Internet</Select.Option>
                <Select.Option value="television">Television</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          {this.props.rate.section === "internet" && (
            <Col span={24}>
              <Form.Item name="internet_type" label="Tipo de Internet">
                <Select
                  name="internet_type"
                  defaultValue="fibraNadunet"
                  onChange={(value) => this.props.handleInternetSelected(value)}
                  options={[
                    { value: "fibraNadunet", label: "Fibra Nadunet" },
                    { value: "wifiNadunet", label: "Wifi Nadunet" },
                    { value: "fibraDirectaTTB", label: "Fibra Directa TTB" },
                    {
                      value: "fibraIndirectaTTB",
                      label: "Fibra Indirecta TTB",
                    },
                  ]}
                />
              </Form.Item>
            </Col>
          )}
          <Col span={24}>
            <Form.Item
              name="title"
              label="Titulo"
              validateStatus={this.props.formErrors.title ? "error" : ""}
              help={
                this.props.formErrors.title ? this.props.formErrors.title : ""
              }
            >
              <Input
                name="title"
                onChange={(event) => this.props.handleInputChange(event)}
                style={{ width: "100%" }}
                placeholder="Ingresa el título"
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="description"
              label="Descripción"
              validateStatus={this.props.formErrors.description ? "error" : ""}
              help={
                this.props.formErrors.description
                  ? this.props.formErrors.description
                  : ""
              }
            >
              <Input
                name="description"
                onChange={(event) => this.props.handleInputChange(event)}
                style={{ width: "100%" }}
                placeholder="Ingresa la descripción"
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="price"
              label="Precio"
              validateStatus={this.props.formErrors.price ? "error" : ""}
              help={
                this.props.formErrors.price ? this.props.formErrors.price : ""
              }
            >
              <Input
                suffix="€"
                name="price"
                onChange={(event) => this.props.handleInputChange(event)}
                style={{ width: "100%" }}
                placeholder="Ingresa el precio"
              />
            </Form.Item>
          </Col>
          {this.props.rate.section !== "internet" && (
            <Col span={24}>
              <Typography.Text style={{ marginBottom: "8px" }}>
                Descuentos por Internet
              </Typography.Text>
              <Form.List name="discounts_list">
                {(fields, { add, remove }) => (
                  <Space direction="vertical" style={{ width: "100%" }}>
                    {fields.map(({ key, name, ...restField }, index) => (
                      <div
                        key={key}
                        style={{
                          display: "flex",
                          gap: 4,
                          marginBottom: 8,
                          width: "100%",
                        }}
                        align="baseline"
                      >
                        <div
                          style={{
                            flexGrow: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Form.Item
                            {...restField}
                            name={[name, "internet_id"]}
                            style={{ width: "100%", margin: 0 }}
                            validateStatus={
                              this.props.formErrors.discounts ? "error" : ""
                            }
                          >
                            <Select
                              style={{ width: "100%" }}
                              placeholder="Plan de internet"
                              options={this.state.internet}
                              onChange={(value) =>
                                this.props.handleChangeDiscount(
                                  index,
                                  "internet_id",
                                  value
                                )
                              }
                            />
                          </Form.Item>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Form.Item
                            {...restField}
                            name={[name, "discount_type"]}
                            style={{ width: "100%", margin: 0 }}
                            validateStatus={
                              this.props.formErrors.discounts ? "error" : ""
                            }
                          >
                            <Select
                              style={{ width: "100%" }}
                              placeholder="Tipo de descuento"
                              onChange={(value) =>
                                this.props.handleChangeDiscount(
                                  index,
                                  "discount_type",
                                  value
                                )
                              }
                            >
                              <Select.Option value="percentage">
                                Porcentual
                              </Select.Option>
                              <Select.Option value="specific amount">
                                Monto fijo
                              </Select.Option>
                            </Select>
                          </Form.Item>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Form.Item
                            {...restField}
                            name={[name, "discount_amount"]}
                            style={{ width: "100%", margin: 0 }}
                            validateStatus={
                              this.props.formErrors.discounts ? "error" : ""
                            }
                          >
                            <Input
                              suffix={
                                this.props.rate.discounts[index] &&
                                this.props.rate.discounts[index]
                                  .discount_type === "percentage"
                                  ? "%"
                                  : "€"
                              }
                              name="new_price"
                              style={{ width: "100%" }}
                              placeholder={
                                this.props.rate.discounts[index] &&
                                this.props.rate.discounts[index]
                                  .discount_type === "percentage"
                                  ? "Ingresar el porcentaje"
                                  : "Ingresar nuevo precio"
                              }
                              onChange={(event) =>
                                this.props.handleChangeDiscount(
                                  index,
                                  "discount_amount",
                                  event.target.value
                                )
                              }
                            />
                          </Form.Item>
                        </div>
                        <MinusCircleOutlined
                          onClick={() => {
                            this.props.handleRemoveDiscount(index);
                            remove(name);
                          }}
                        />
                      </div>
                    ))}
                    <Form.Item
                      validateStatus={
                        this.props.formErrors.title ? "error" : ""
                      }
                      help={
                        this.props.formErrors.discounts
                          ? this.props.formErrors.discounts
                          : ""
                      }
                    >
                      <Button
                        type="dashed"
                        onClick={() => this.props.handleAddDiscount(add)}
                        block
                        icon={<PlusOutlined />}
                      >
                        Añadir descuento
                      </Button>
                    </Form.Item>
                  </Space>
                )}
              </Form.List>
            </Col>
          )}
          <Col span={24}>
            <Form.Item name="status" label="Estado">
              <Switch
                checked={this.props.rate.status}
                onChange={(event) => this.props.handleInputChange(event)}
              />
            </Form.Item>
          </Col>
          <Space>
            <Button onClick={() => this.props.handleCancelForm()}>
              Cancelar
            </Button>
            <Button
              onClick={() =>
                this.props.isNewRate
                  ? this.props.handleFormSubmit(this.props.rate.section)
                  : this.props.handleEditForm(this.props.rate.section)
              }
              type="primary"
              disabled={
                Object.keys(this.props.formErrors).length !== 0 ||
                this.props.rate.title.length < 1
              }
            >
              {this.props.isNewRate ? "Crear servicio" : "Editar servicio"}
            </Button>
          </Space>
        </Form>
      </Drawer>
    );
  }
}

export default RatesDrawer;



// WEBPACK FOOTER //
// ./src/views/Configurator/components/RatesDrawer.jsx